// ============================================================
// WHAT YOU'LL LEARN — default body content (single source of truth)
// ============================================================
// The ORIGINAL default body ("bullets") for the "What You'll Learn" dynamic
// component lives here ONCE and is shared by:
//
//   * the Course Visual Page template (courseTemplate.js), which seeds the
//     first What You'll Learn on every new course page, and
//   * the node registry defaultProps in PageEditor.js, which `makeNode` clones
//     when a What You'll Learn is dragged in from the palette.
//
// Because both read this same constant, a template-born instance and a
// manually-added instance START with byte-identical body content — a newly
// added What You'll Learn matches the existing/template one instead of showing
// a divergent generic placeholder.
//
// This is a STATIC default, not another instance's live state: the drop path
// reads it (via the registry) rather than copying any existing node's props, so
// editing one instance never affects another and edited content is never
// inherited.
//
// NOTE: the heading is NOT here — it is a global value resolved at render time
// (`resolveWhatYouLearnHeading` -> globalContentStore) and is deliberately not
// a node prop. Nothing in this module touches the heading.

// One item per line; matches the course template's reference copy.
export const WYL_DEFAULT_BULLET_LIST = [
  'How MLB scouts evaluate players across the five tools: hit, power, run, throw, field',
  'How to write professional scouting reports recognized by MLB standards',
  'The structure of MLB front offices and how decisions get made',
  'Prepare for real-world baseball jobs, from scouting internships to front office roles',
  'Draft and player development strategy',
  'Networking secrets for building relationships in MLB and MiLB',
  'Breaking into roles in scouting, player development, or baseball analytics',
];

// The `bullets` prop is stored as one newline-joined string (one item per line).
export const WYL_DEFAULT_BULLETS = WYL_DEFAULT_BULLET_LIST.join('\n');
